module.exports = __webpack_public_path__ + "assets/img/skype.ccc797c7.svg";